"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orange500 = exports.orange400 = exports.orange300 = exports.orange200 = exports.orange100 = exports.grey500 = exports.grey400 = exports.grey300 = exports.grey200 = exports.grey100 = exports.colorScaleCategorical = exports.blue500 = exports.blue400 = exports.blue300 = exports.blue200 = exports.blue100 = void 0;
var _d3Scale = require("d3-scale");
// hardcoded colors
var blue100 = "#BBDEFB";
exports.blue100 = blue100;
var blue200 = "#90CAF9";
exports.blue200 = blue200;
var blue300 = "#64B5F6";
exports.blue300 = blue300;
var blue400 = "#42A5F5";
exports.blue400 = blue400;
var blue500 = "#1890FF";
exports.blue500 = blue500;
var grey100 = "#F2F2F2";
exports.grey100 = grey100;
var grey200 = "#EEEEEE";
exports.grey200 = grey200;
var grey300 = "#E0E0E0";
exports.grey300 = grey300;
var grey400 = "#BDBDBD";
exports.grey400 = grey400;
var grey500 = "#9E9E9E";
exports.grey500 = grey500;
var orange100 = "#FFCB7F";
exports.orange100 = orange100;
var orange200 = "#FFBE5E";
exports.orange200 = orange200;
var orange300 = "#FFB74D";
exports.orange300 = orange300;
var orange400 = "#FFAD35";
exports.orange400 = orange400;
var orange500 = "#FF9F14";

// color scales
exports.orange500 = orange500;
var colorScaleCategorical = function colorScaleCategorical() {
  return (0, _d3Scale.scaleOrdinal)([blue500, blue400, blue300, blue200, blue100, grey100, grey200, grey300, grey400, grey500, orange500, orange400, orange300, orange200, orange100]);
};
exports.colorScaleCategorical = colorScaleCategorical;